<div class="wrapper flex flex--column rounded-large border">
  <div class="card-container flex">
    <div class="product-image relative">
      <fcom-image
        *ngIf="image"
        class="picture"
        [ratio]="imageRatio$ | async"
        [alt]="image.alt"
        [fillParent]="true"
        [imageData]="image"
        [style.minHeight.px]="notifications.clientHeight"
      ></fcom-image>
      <div class="notification" [ngClass]="{ 'mr-small has-image': image }" #notifications>
        <ng-content select="fcom-notification, [notifications]"></ng-content>
      </div>
    </div>

    <div class="details font-body-1 white-bg ps-medium flex-1" [ngClass]="{ 'has-image': image }">
      <div class="destinations font-heading-3 nordic-blue-900-text">
        <span [title]="destinations ? destinations.join(' - ') : ''">
          <span *ngFor="let pair of destinationPairs; index as i; last as last" class="destination ms-xsmall-r">
            <span>{{ pair[0] }}</span>
            <fcom-icon
              class="icon-medium"
              [name]="journeyType === JourneyType.RETURN ? 'return-trip' : 'aircraft-horizontal'"
            ></fcom-icon>
            <span>{{ pair[1] }}</span>
            <span *ngIf="!last">, </span>
          </span>
        </span>
      </div>
      <div class="timeline nordic-blue-900-text ms-small-t">
        {{ departureDate }}{{ arrivalDate ? ' - ' + arrivalDate : '' }}
      </div>
      <div class="passengers pr-xsmall-r" *ngIf="passengerAmount">
        {{
          (passengerAmount === 1 ? 'tripCard.passenger' : 'tripCard.passengers') | finLocalization: { passengerAmount }
        }}
      </div>
      <div class="ms-small-t" *ngIf="journeyType || bookingRef">
        <fcom-chip class="booking-ref ms-xxsmall-r" *ngIf="bookingRef">{{
          'tripCard.bookingReference' | finLocalization: { bookingRef }
        }}</fcom-chip>
        <fcom-chip class="flight-type" *ngIf="journeyType">{{
          'tripCard.tripType.' + journeyType | finLocalization
        }}</fcom-chip>
      </div>
      <div
        *ngIf="flightTotalPriceAmount || !showExpandButton"
        class="flex flex--space-between flex--align-center ms-small-t font-heading-4 nordic-blue-900-text"
      >
        <div *ngIf="flightTotalPriceAmount" class="total-amount">
          {{ flightTotalPriceAmount }}
        </div>
        <div class="start-over">
          <a
            href
            class="block align-center nordic-blue-900-text bold-type font-body-1 no-underline"
            (click)="clickCta($event)"
          >
            <span>{{ 'tripCard.startOver' | finLocalization }}</span>
            <fcom-icon name="arrow-back" class="icon-medium"></fcom-icon>
          </a>
        </div>
      </div>

      <div *ngIf="showExpandButton" class="expand-details flex flex--align-end flex--shrink0 ms-small-t">
        <button
          [attr.aria-label]="(expanded ? 'tripCard.ariaHide' : 'tripCard.ariaShow') | finLocalization"
          [attr.aria-controls]="expandContainerId"
          [attr.aria-expanded]="expanded"
          [id]="expandButtonId"
          (click)="toggleExpand($event)"
          class="font-body-1 mr-small-l nordic-blue-900-text underline medium-type"
        >
          <span>{{ (expanded ? 'tripCard.hideFlights' : 'tripCard.showFlights') | finLocalization }}</span>
          <fcom-icon [class.chevron-open]="expanded" class="icon-medium ms-xxsmall-l chevron" name="chevron-down">
          </fcom-icon>
        </button>
      </div>
    </div>
  </div>

  <div *ngIf="showExpandButton">
    <fcom-expand [open]="expanded" [ariaId]="expandContainerId" [ariaLabelledBy]="expandButtonId" class="block">
      <div class="expanded-content">
        <ng-content></ng-content>
      </div>
    </fcom-expand>
  </div>
</div>
